import React from "react";
import { Flex, Text, MenuButton, MoreIcon } from '@fluentui/react-northstar'
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";
import { useMst } from "../../../hooks/useMst";
import Constants from "../../../constants/text-constants";

const LocationListItem = observer((props) => {
    const { testId, location, onEditClicked, onDeleteClicked } = props;
    const { permissionStore } = useMst();

    const createMenuItems = () => {
        let items = [];
        const hasPermissionsEditLocation = permissionStore.havePermissions("Locations", ["Edit"]);
        const hasPermissionsDeleteLocation = permissionStore.havePermissions("Locations", ["Delete"]);

        if (hasPermissionsEditLocation) {
            items.push({
                key: "locationListItemEditMenu-" + location.code,
                content: (<Text>{Constants.EDIT}</Text>),
                onClick: onMenuClickEdit
            });
        }

        if (hasPermissionsDeleteLocation) {
            items.push({
                key: "locationListItemDeleteMenu-" + location.code,
                content: (<Text error>{Constants.DELETE}</Text>),
                onClick: onMenuClickDelete
            });
        }
        return items;
    }

    const onMenuClickEdit = () => {
        onEditClicked(location);
    }

    const onMenuClickDelete = () => {
        onDeleteClicked(location);
    }

    const menuItems = createMenuItems();

    return (
        <React.Fragment>
            <Flex className="settings-locations-list-item" space="between" vAlign="center" data-testid={testId}>
                <Flex className="settings-location-list-item-text-container" padding="padding.medium" vAlign="center" column>
                    <Text align="start" weight="bold" truncated>{location.description}</Text>
                    <Text align="start" >{location.phoneNumber}</Text>
                </Flex>
                {menuItems.length ?
                    (<Flex vAlign="center">
                        <MenuButton data-testid="locationListItemMenuButton" trigger={<MoreIcon />} menu={menuItems} />
                    </Flex>) : null}
            </Flex>
            
        </React.Fragment>
    );
});


LocationListItem.propTypes = {
    location: PropTypes.object,
    testId: PropTypes.string,
    onEditClicked: PropTypes.func,
    onDeleteClicked: PropTypes.func,
};

LocationListItem.defaultProps = {
    location: {
        code: "",
        description: "",
        phoneNumber: "",
    },
    testId: "",
};

export default LocationListItem;
